package com.schoolconnect.app.feature.common

data class FeatureEntry(
    val id: String,
    val title: String,
    val group: String,
    val description: String
)

val featureCatalog = listOf(
    FeatureEntry("home", "Home", "Shell", "Entry point for the new app shell."),
    FeatureEntry("auth", "Auth", "Access", "Login, OTP, registration, and session handling."),
    FeatureEntry("schools", "Schools", "Master Data", "School records and scope management."),
    FeatureEntry("school-users", "School Users", "Master Data", "School management and administration users."),
    FeatureEntry("it-users", "IT Support Users", "Operations", "Platform support, developer, and DevOps users."),
    FeatureEntry("help-desk", "Support Queue", "Operations", "Review and manage support tickets raised across schools."),
    FeatureEntry("academic-years", "Academic Years", "Master Data", "Academic year configuration."),
    FeatureEntry("classes", "Classes", "Master Data", "Class and section management."),
    FeatureEntry("students", "Students", "Master Data", "Student records and enrollment."),
    FeatureEntry("my-students", "My Students", "Academics", "Teacher-assigned student performance."),
    FeatureEntry("teachers", "Teachers", "Master Data", "Teacher records and assignments."),
    FeatureEntry("parents", "Parents", "Master Data", "Parent records and linkages."),
    FeatureEntry("school-staff", "School Staff", "Master Data", "School staff records and roles."),
    FeatureEntry("links", "Links", "Master Data", "Relationship and assignment links."),
    FeatureEntry("subjects", "Subjects", "Master Data", "Subject catalog and mappings."),
    FeatureEntry("notices", "Notices", "Operations", "Notice publishing and audience targeting."),
    FeatureEntry("quick-announcements", "Quick Announcements", "Communication", "Short, time-bound announcements for parents."),
    FeatureEntry("events-news", "Events & News", "Communication", "Create and manage school events and news."),
    FeatureEntry("parent-notes", "Parent Notes", "Communication", "Teacher-parent notes and response tracking."),
    FeatureEntry("class-conversations", "Class Conversations", "Communication", "Parent class conversation list and replies."),
    FeatureEntry("document-library", "Document Library", "Communication", "Upload and manage documents for school users."),
    FeatureEntry("support-center", "Support Center", "Support", "Find help and manage your support tickets."),
    FeatureEntry("calendar", "Calendar", "Operations", "School calendar and event flows."),
    FeatureEntry("time-table", "Time Table", "Operations", "Create and manage class timetables."),
    FeatureEntry("attendance", "Attendance", "Operations", "Attendance capture and review."),
    FeatureEntry("homework", "Homework", "Operations", "Homework assignment and tracking."),
    FeatureEntry("exams", "Exams", "Operations", "Exam setup and results."),
    FeatureEntry("imports", "Bulk Import", "Utilities", "Spreadsheet import and reconciliation tools."),
    FeatureEntry("school-config", "School Configuration", "Master Data", "Manage school-level configuration settings."),
    FeatureEntry("config", "Config", "Utilities", "Environment and app configuration."),
)
